// Added by Jonghyung Lee on 2020-11-02
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios, { AxiosResponse } from 'axios'
import { LanguageInterface } from '@/helper/define/systemConfigDefine'

export const reqGetSystemLanguageConfig = async (): Promise<AxiosResponse<LanguageInterface[]>> => {
  return await axios.get('v1/system/languages')
}

export const reqCreateSystemLanguageConfig = async (lang: FormData) => {
  return await axios.post('v1/system/languages', lang)
}

export const reqDeleteSystemLanguageConfig = async (langCode: string) => {
  return await axios.delete(`v1/system/languages/${langCode}`)
}
